import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SkeletonLine } from '~/techstyle-shared/react-components';

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 8px;
`;

const ProductCardSkeleton = ({ width, height }) => {
  return (
    <SkeletonWrapper>
      <SkeletonLine width={width} height={height * 0.7} />
      <SkeletonLine width={width} height="16px" />
      <SkeletonLine width={width} height="16px" />
      <SkeletonLine width={width * 0.5} height="16px" />
    </SkeletonWrapper>
  );
};

ProductCardSkeleton.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ProductCardSkeleton;
